<app-bread-crumb
  [items]="[{ text: 'pedidos', link: '/admin/orders/list' }, { text: 'Itens' }]"
  [sectionTitle]="'Pedidos do sr.: ' + order?.member?.name"
></app-bread-crumb>

<section class="content">
  <div class="row">
    <div class="col-md-12">
      <!-- inicio do box -->
      <ng-box [boxIcon]="'fa fa-shopping-cart'" [boxTitle]="'Itens'">
        <!-- cabesalho do box -->
        <ng-container class="ng-box-header">
          <ng-button
            (click)="router.navigate(['/admin/orders/list'])"
            [button]="{
              name: 'back',
              faIconClass: 'fa fa-arrow-left',
              color: 'secondary'
            }"
          >
          </ng-button>
        </ng-container>

        <!-- conteudo do box -->
        <ng-container class="ng-box-content">
          <ng-table [tableHeaderAndFooterColumns]="tableProprieties()">
            <tr *ngFor="let item of order?.items; index" ngChangeColorOnHover>
              <td>
                <span style="font-size: large; color: #f35309">{{
                  item?.item?.product?.title
                }}</span>
              </td>

              <td>
                <span>{{ item?.quantity }}</span>
              </td>

              <td>{{ item?.amount | currency: "MZN":"symbol" }}</td>

              <!-- <td>
                <span class="label label-success">{{ item?.status }}</span>
              </td> -->

              <!-- <ng-actions-table-bar>

                    <ng-button
                      title="Mais Detalhes"
                      (click)="detail(order)"
                      [button]="{faIconClass:'fa fa-eye',color:'danger'}"
                    ></ng-button>

                  </ng-actions-table-bar> -->
            </tr>
          </ng-table>
          <!-- fim da tabela -->
          <!-- <box-loading class="overlay" *ngIf="isSpinnerLoading"></box-loading> -->
        </ng-container>
        <!-- fim do conteudo -->
      </ng-box>
    </div>
  </div>
</section>
